import { env } from 'shared/library/env';

/** "Version 1.2.3 · abc1234 · 2026-10-27 16:40 UTC", omitting parts a local build lacks. */
export function formatAppVersion() {
  const deployedAt = env.APP_DEPLOYED_AT
    ? `${env.APP_DEPLOYED_AT.slice(0, 16).replace('T', ' ')} UTC`
    : '';

  return [`Version ${env.APP_VERSION}`, env.APP_COMMIT, deployedAt].filter(Boolean).join(' · ');
}
